import React from "react";
import logoImage from "../../asset/logo.png";
import "./FileTransferPromoOverlay.css";

const COURT_IMAGE_SOURCE = `${process.env.PUBLIC_URL}/tt-table.webp`;
const FILE_BALL_IMAGE_SOURCE = `${process.env.PUBLIC_URL}/file-transfer-tt-ball.webp`;
const RACKET_IMAGE_SOURCE = `${process.env.PUBLIC_URL}/blue-racket.webp`;
const FILE_TRANSFER_CTA_TEXT = "Paste here. Pick up anywhere.";

const FileTransferPromoOverlay = ({ isVisible, phase }) => {
  if (!isVisible) return null;

  return (
    <div
      aria-hidden="true"
      className={`file-transfer-promo file-transfer-promo--${phase}`}
      data-phase={phase}
      data-testid="file-transfer-promo-overlay"
    >
      <img
        alt=""
        className="file-transfer-promo__court"
        draggable="false"
        src={COURT_IMAGE_SOURCE}
      />
      <img
        alt=""
        className="file-transfer-promo__racket file-transfer-promo__racket--left"
        draggable="false"
        src={RACKET_IMAGE_SOURCE}
      />
      <img
        alt=""
        className="file-transfer-promo__racket file-transfer-promo__racket--right"
        draggable="false"
        src={RACKET_IMAGE_SOURCE}
      />
      <img
        alt=""
        className="file-transfer-promo__file"
        draggable="false"
        src={FILE_BALL_IMAGE_SOURCE}
      />
      <div className="file-transfer-promo__cta">
        <p className="file-transfer-promo__cta-text">{FILE_TRANSFER_CTA_TEXT}</p>
        <div className="file-transfer-promo__brand">
          <img
            alt=""
            className="file-transfer-promo__brand-logo"
            draggable="false"
            src={logoImage}
          />
          <span className="file-transfer-promo__brand-text">Netpad.click</span>
        </div>
      </div>
    </div>
  );
};

export default FileTransferPromoOverlay;
